const {h, render, Component} = require('preact');

class WidgetsView extends Component {
    constructor(props) {
        super(props);
    };

    componentDidUpdate() {
        if(Groupon.Utils)
            Groupon.Utils.lazyLoadImages()
        window.cardUI.init()
    }

    render() {
        let widgets = this.props.widgets
        if (widgets) {
            return (
                <section className="main row cs_support_header" id="contact-us-body-content">
                    <div className="twelve columns">
                        <section className="module">
                            <div className="module-body contact-us">
                                <div className="row">
                                    <div class="thank_you">
                                        <div>
                                            <hr/>
                                            <div dangerouslySetInnerHTML={{__html: widgets}}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </section>
            );
        }
        return null
    }
}

module.exports = WidgetsView
